module.exports = "/images/pillPaxIcon.png?5dcc016e991d4c14c9b0f85bff5eb8d8";